module.exports = __webpack_public_path__ + "static/ENmobSlide5-72ad3f9892d5fea06e60eb0ea5286545.jpg";